import CompanyTable from "./company-table";

export default CompanyTable;